import formatFileSize from './utils'

const messages = {
  _default: () => `hodnota není platná`,
  after: (field, [target, , inclusion]) =>
    `musí být po ${inclusion ? 'nebo rovno' : ''}${target}.`,
  alpha_dash: () =>
    `pole může obsahovat alfanumerické znaky, také pomlčky a podtržítka.`,
  alpha_num: () =>
    `pole může obsahovat pouze alfanumerické znaky.`,
  alpha: () =>
    `pole může obsahovat pouze abecední znaky.`,
  alpha_spaces: () =>
    `pole může obsahovat pouze abecední znaky a mezery.`,
  before: (field, [target, inclusion]) =>
    `musí být před  ${inclusion ? 'nebo rovno' : ''}${target}.`,
  between: (field, [min, max]) =>
    `pole musí být mezi ${min} a ${max}.`,
  confirmed: () =>
    `potvrzení se neshoduje.`,
  credit_card: () =>
    `pole je neplatné.`,
  date_between: (field, [min, max]) =>
    `musí být mezi ${min} a ${max}.`,
  date_format: (field, [format]) =>
    `musí být ve formátu ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `pole musí být číselné a může obsahovat  ${!decimals || decimals === '*' ? '' : decimals} desetinných míst.`,
  digits: (field, [length]) =>
    `pole musí být číselné a přesně obsahovat ${length} číslice.`,
  dimensions: (field, [width, height]) =>
    `pole musí být ${width} pixelů do ${height} pixelů.`,
  email: () =>
    `pole musí být platný e-mail.`,
  ext: () =>
    `pole musí být platný soubor`,
  image: () =>
    `pole musí být obrázek`,
  in: () =>
    `pole musí být platná hodnota`,
  integer: () =>
    `pole musí být celé číslo`,
  ip: () =>
    `pole musí být platná ip adresa`,
  length: (field, [length, max]) => {
    if (max) {
      return `délka musí být mezi ${length} a ${max}.`
    }

    return `délka musí být ${length}.`
  },
  max: (field, [length]) =>
    `pole nesmí být větší než ${length} znaků.`,
  max_value: (field, [max]) =>
    `pole musí být ${max} nebo méně.`,
  mimes: () =>
    `pole musí mít platný typ souboru.`,
  min: (field, [length]) =>
    `pole musí mít alespoň ${length} znaků.`,
  min_value: (field, [min]) =>
    `pole musí být ${min} nebo více.`,
  not_in: () =>
    `pole musí být platná hodnota.`,
  numeric: () =>
    `pole může obsahovat pouze číselné znaky`,
  regex: () =>
    `formát pole je neplatný`,
  required: () =>
    `pole je povinné`,
  size: (field, [size]) => `velikost musí být menší než ${formatFileSize (size)}.`,
  url: () => `pole není platná URL.`,
  fullName: () => `není platný (křestní jméno a příjmení, a max. 120 znaků)`,
  emailInput: () => 'pole musí být platný e-mail.',
  fullNamePerCountry: () => 'není platný (křestní jméno a příjmení, a max. 18 znaků)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'cs',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/cs.js